import styled from '@emotion/styled';
import { Button, Divider } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { FaUser } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { ConnectedUserEntity } from '../../entities/ConnectedUserEntity';
import { ConversationEntity } from '../../entities/conversation.entity';
import { MessageEntity } from '../../entities/message.entity';
import { UserEntity } from '../../entities/utilisateur.entity';
import { Layout } from '../../modules/shared/Layout';
import { ORANGE } from '../../shared/colors';
import {
  addMessage,
  findConversation,
  getConversations,
  getSetUsers,
} from '../dashboard/network';
import Loading from '../shared/Loading';

const Container = styled.div`
  display: flex;
  width: 100%;
  margin-top: 2px;
  padding: 10px;
  color: var(--mt-text);

  .main {
    display: flex;
    width: 100%;
    padding: 10px;
    gap: 10px;
    height: calc(100vh - 60px);
  }
  .left,
  .right {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .left {
    flex: 1;
  }

  .right {
    flex: 2;
  }

  .search-container {
    position: relative;
    margin: 20px auto;
  }

  .search-input {
    width: 100%;
    padding: 10px 12px;
    color: black;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 16px;
  }

  li {
    list-style-type: none;
    margin-left: 0px;
  }

  .search-dropdown {
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    margin-top: 5px;
    max-height: 240px;
    overflow-y: auto;
    color: black;
    z-index: 10;
  }

  .search-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    cursor: pointer;
    transition: background 0.2s;
  }

  .search-item:hover {
    background-color: #f5f5f5;
  }

  .user-avatar {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    object-fit: cover;
    float: left;
    margin-right: 5px;
  }

  .user-avatar1 {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    float: left;
    margin-right: 5px;
  }

  .user-info {
    display: flex;
    flex-direction: column;
    margin-bottom: 5px;
  }

  .user-name h3 {
    font-weight: 500;
    color: var(--mt-text);
  }

  .conversation-div {
    margin-top: 10px;
    padding: 5px;
  }

  .conversation-div: hover {
    background: orange;
  }

  .user-username {
    font-size: 13px;
    color: #777;
    margin: 0px;
  }

  .box {
    background-color: var(--mt-surface);
    border-radius: 5px;
    padding: 10px;
    flex: 1;
    overflow: auto;
    border: 1px solid grey;
  }

  .chat-box {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 10px;
    background-color: var(--mt-surface);
    border-radius: 5px;
    border: 1px solid grey;
  }

  .chat-messages {
    flex: 1;
    padding: 10px;
    overflow-y: auto;
    margin-bottom: 10px;
  }

  .messages {
    margin-bottom: 12px;
    padding: 10px 14px;
    border-radius: 20px;
    max-width: 70%;
    clear: both;
  }

  .messages.received {
    background-color: #e9ecef;
    align-self: flex-start;
    color: #1c2025;
  }

  .messages.sent {
    background-color: #0d6efd;
    color: var(--mt-text);
    align-self: flex-end;
    margin-left: auto;
  }

  .form-control textarea {
    width: 100%;
    height: 60px;
    border-radius: 6px;
    padding: 8px;
    margin-bottom: 10px;
  }
`;
export const ConversationsPage = () => {
  const [keyword, setKeyword] = useState('');
  const [results, setResults] = useState([]);
  const [conversations, setConversations] = useState<ConversationEntity[]>([]);
  const [conversation, setConversation] = useState<ConversationEntity>();
  const [showDropdown, setShowDropdown] = useState(false);
  const timeoutRef = useRef<number | undefined>(undefined);
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;
  const [isLoading, setLoading] = useState(false);
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    setKeyword(value);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = window.setTimeout(() => {
      if (value.trim() === '') {
        setResults([]);
        return;
      }
      getSetUsers(keyword).then(({ data }) => {
        setResults(data);
        setShowDropdown(true);
      });
    }, 0); // délai de 300ms
  };

  const seeConversation = (user_id) => {
    findConversation(connectedUser.id, user_id).then(({ data }) => {
      setConversation(data);
      setLoading(false);
    });
  };

  const changeConversation = (conv: ConversationEntity) => {
    console.log(conv);
    setConversation(conv);
  };

  const sendMessage = () => {
    const textarea = document.getElementById('mess') as HTMLTextAreaElement;
    const value = textarea.value;
    if (conversation) {
      var mess = new MessageEntity();
      mess.sender = connectedUser.url;
      mess.content = value;
      mess.conversation = conversation.url;

      //save to database
      addMessage(mess).then(({ data }) => {
        setLoading(false);
        const textarea = document.getElementById('mess') as HTMLTextAreaElement;
        textarea.value = '';
        //add to conversation
        conversation.messages.push(mess);
        setConversation(conversation);
      });
    } else {
      alert('Ouvrez une conversation!');
    }
  };

  const fetchData = () => {
    setLoading(true);
    getConversations(connectedUser.id).then(({ data }) => {
      setConversations(data);
      setLoading(false);
    });
  };

  return isLoading ? (
    <Loading />
  ) : (
    <Layout>
      <Container>
        <div className='main'>
          <div className='left'>
            <div className='box'>
              <h3 style={{ color: 'orange', marginTop: 20 }}>
                Liste des Conversations
              </h3>
              <Divider
                style={{ backgroundColor: 'orange', marginBottom: 10 }}
              />
              <div className='p-4 max-w-md mx-auto'>
                <input
                  type='text'
                  placeholder='Search user...'
                  value={keyword}
                  onChange={handleChange}
                  onFocus={() => keyword && setShowDropdown(true)}
                  onBlur={() => setTimeout(() => setShowDropdown(false), 200)} // délai pour permettre clic
                  className='search-input'
                />
                {showDropdown && results.length > 0 && (
                  <ul className='search-dropdown'>
                    {results.map((user: UserEntity) => (
                      <li
                        key={user.id}
                        className='px-4 py-2 hover:bg-gray-100 cursor-pointer'
                        onClick={() => seeConversation(user.id)}
                      >
                        <FaUser size={10} className='user-avatar' />
                        <div className='user-info'>
                          <div className='user-name'>
                            {user.prenom} {user.nom}
                          </div>
                        </div>
                        <Divider
                          style={{
                            backgroundColor: 'orange',
                            marginBottom: 5,
                          }}
                        />
                      </li>
                    ))}
                  </ul>
                )}
                {showDropdown && keyword && results.length === 0 && (
                  <div className='search-dropdown'>
                    Aucun utilisateur trouvé.
                  </div>
                )}
                <div>
                  {conversations.map((conversation) => (
                    <div
                      className='conversation-div'
                      key={conversation.id}
                      onClick={() => changeConversation(conversation)}
                    >
                      <FaUser size={10} className='user-avatar1' />
                      <div className='user-info'>
                        <div className='user-name'>
                          <h3>
                            {
                              (conversation.participant1.id = connectedUser.id
                                ? conversation.participant2.prenom
                                : conversation.participant1.prenom)
                            }{' '}
                            {
                              (conversation.participant1.id = connectedUser.id
                                ? conversation.participant2.nom
                                : conversation.participant1.nom)
                            }
                          </h3>
                          <p className='message'>
                            {conversation.messages.length > 0
                              ? conversation.messages[0].content
                              : ''}
                          </p>
                          <p className='time'>
                            {conversation.messages.length > 0
                              ? conversation.messages[0].timestamp
                              : ''}
                          </p>
                        </div>
                      </div>
                      <Divider
                        style={{ backgroundColor: 'orange', marginBottom: 5 }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className='right'>
            <div className='chat-box'>
              <div className='chat-messages'>
                {conversation?.messages.map((mess: MessageEntity) => (
                  <div
                    key={mess.id}
                    className={` ${
                      mess.sender === connectedUser.url
                        ? 'messages received'
                        : 'messages sent'
                    }`}
                  >
                    <p>{mess.content}</p>
                    <p>{mess.timestamp}</p>
                  </div>
                ))}
              </div>
              <div className='form-control'>
                <textarea placeholder='Écrivez un message...'></textarea>
                <Button
                  onClick={() => sendMessage()}
                  type='primary'
                  htmlType='submit'
                  loading={isLoading}
                  style={{
                    backgroundColor: ORANGE,
                    borderWidth: 0,
                    borderRadius: 5,
                    marginBottom: 20,
                  }}
                >
                  Send
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Layout>
  );
};
